/**
 * 数学计算的系列函数
 * @param {*} param
 * @return param.a ? param.b
 */

const plus = {
    fn: (a, b) => +a + b,
    desc: '需要两个参数(a, b)，返回 +a + b',
};

const plusToFixed = {
    fn: (a, b, c) => (+a + b).toFixed(c),
    desc: '需要三个参数(a, b, c)，返回 (+a + b).toFixed(c)',
};

const subtract = {
    fn: (a, b) => a - b,
    desc: '需要两个参数(a, b)，返回 a - b',
};

const subtractToFixed = {
    fn: (a, b, c) => (a - b).toFixed(c),
    desc: '需要三个参数(a, b, c)，返回 (a - b).toFixed(c)',
};

const subtractReverse = {
    fn: (a, b) => b - a,
    desc: '需要两个参数(a, b)，返回 b - a',
};

const subtractReverseToFixed = {
    fn: (a, b, c) => (b - a).toFixed(c),
    desc: '需要三个参数(a, b, c)，返回 (b - a).toFixed(c)',
};

const multiply = {
    fn: (a, b) => a * b,
    desc: '需要两个参数(a, b)，返回 a * b',
};

const multiplyToFixed = {
    fn: (a, b, c) => (a * b).toFixed(c),
    desc: '需要三个参数(a, b, c)，返回 (a * b).toFixed(c)',
};

const divide = {
    fn: (a, b) => a / b,
    desc: '需要两个参数(a, b)，返回 a / b',
};

const divideToFixed = {
    fn: (a, b, c) => (a / b).toFixed(c),
    desc: '需要三个参数(a, b, c)，返回 (a / b).toFixed(c)',
};

const divideReverse = {
    fn: (a, b) => b / a,
    desc: '需要两个参数(a, b)，返回 b / a',
};

const divideReverseToFixed = {
    fn: (a, b, c) => (b / a).toFixed(c),
    desc: '需要三个参数(a, b, c)，返回 (b / a).toFixed(c)',
};

const toFixed = {
    fn: (a, b) => (+a).toFixed(+b),
    desc: '需要两个参数(a, b)，返回 a.toFixed(b)',
};

const toFixedReverse = {
    fn: (a, b) => (+b).toFixed(+a),
    desc: '需要两个参数(a, b)，返回 b.toFixed(a)',
};

const mathFn = {
    fn: (val, FunctionName, ...extra) => Math[FunctionName](val, ...extra),
    desc: '需要至少两个参数(val, FunctionName, ...extra)，返回 Math[FunctionName](val, ...extra)',
};

export default {
    plus,
    plusToFixed,
    subtract,
    subtractToFixed,
    subtractReverse,
    subtractReverseToFixed,
    multiply,
    multiplyToFixed,
    divide,
    divideToFixed,
    divideReverse,
    divideReverseToFixed,
    toFixed,
    toFixedReverse,
    mathFn,
};
